import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { adminApi } from "@/lib/api";

const FEATURES = [
  ["audit_seo", "Audit SEO", "#E0262C"],
  ["chatbot", "Chatbot", "#2B3036"],
  ["social_pilot", "Social Pilot", "#f59e0b"],
  ["traduzioni", "Traduzioni", "#10b981"],
  ["altro", "Altro", "#9ca3af"],
];
const usd = (n) => `$${Number(n || 0).toFixed(2)}`;
const label = (d) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;

const Tip = ({ active, payload, label: l }) => {
  if (!active || !payload?.length) return null;
  const tot = payload.reduce((a, p) => a + p.value, 0);
  return (
    <div className="bg-white border border-[#d5dbde] px-3 py-2 text-xs font-mono space-y-0.5">
      <div className="text-[#2B3036] font-medium">{l} · {usd(tot)}</div>
      {payload.filter((p) => p.value > 0).map((p) => <div key={p.dataKey} style={{ color: p.color }}>{p.name}: ${p.value.toFixed(3)}</div>)}
    </div>
  );
};

export const AiUsageChart = () => {
  const [d, setD] = useState(null);
  useEffect(() => { adminApi.aiUsage(30).then(setD).catch(() => setD({ days: [], totals: {}, total_cost: 0 })); }, []);
  if (!d) return null;
  return (
    <div data-testid="ai-usage-chart" className="mt-3 border border-[#d5dbde] bg-white p-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <div className="text-[10px] uppercase tracking-widest font-mono text-[#6b7280]">Consumi AI · ultimi 30 giorni</div>
        <div data-testid="ai-usage-total" className="text-xs font-mono text-[#2B3036]">Totale {usd(d.total_cost)}</div>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={d.days.map((x) => ({ ...x, label: label(x.date) }))}>
            <CartesianGrid stroke="#eef1f2" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "#5b6168", fontSize: 10 }} axisLine={{ stroke: "#d5dbde" }} tickLine={false} interval={4} />
            <YAxis tick={{ fill: "#5b6168", fontSize: 10 }} axisLine={false} tickLine={false} width={42} tickFormatter={(v) => `$${v}`} />
            <Tooltip content={<Tip />} cursor={{ fill: "#eef1f2" }} />
            <Legend wrapperStyle={{ fontSize: 10, fontFamily: "monospace" }} />
            {FEATURES.map(([k, n, c]) => <Bar key={k} dataKey={k} name={n} stackId="a" fill={c} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[11px] font-mono text-[#5b6168]">
        {FEATURES.map(([k, n]) => (
          <span key={k} data-testid={`ai-usage-total-${k}`}>{n}: {usd(d.totals[k]?.cost)} · {d.totals[k]?.calls || 0} richieste</span>
        ))}
      </div>
    </div>
  );
};
